import { render, staticRenderFns } from "./UpdateRobot.vue?vue&type=template&id=2be8e39a"
import script from "./UpdateRobot.vue?vue&type=script&lang=js"
export * from "./UpdateRobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports